/**
 * googleAdsIds — the Google Ads customer-ID normalize/format pair, moved
 * VERBATIM out of TenantSettingsPage (S6) so the integrations section and
 * any remaining legacy consumer share one implementation.
 */

export const normalizeGoogleAdsCustomerId = (value: string | null | undefined) =>
  String(value || '').replace(/\D/g, '');

export const formatGoogleAdsCustomerId = (value: string | null | undefined) => {
  const digits = normalizeGoogleAdsCustomerId(value);
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return digits || 'unknown';
};
